import type { IProductConfigurableAttribute } from '@rogue/universal/dist/cjs/interfaces/catalog/Product'
import { Rogue } from '@/js/services/Rogue'
import { Product } from '@/js/services/RogueTypes'

export function getAttribute(parent: Product, child: Product, attribute: IProductConfigurableAttribute, rogue: Rogue): {title: string, value: string, classes?: string} {
  const value = child.attributes[attribute.code] as string

  if (attribute.code !== 'shoe_size') {
    return { title: attribute.title, value }
  }

  // Pull out all the shoe sizes from the attributes
  const { eu_shoe_size: eu, womens_shoe_size: womens, shoe_size: dflt } = child.attributes || {}

  if (['EUR', 'GBR'].includes(rogue.site.code)) {
    if (eu || child.sku.indexOf('EU-') === 0) {
      // If there is an EU specific size, we want to use that
      return { title: 'Shoe Size', value: (eu || dflt) as string }
    }

    // For ship direct shoes that DON'T have an eu_shoe_size, we show the US shoe size - and they will use fit guide to check
    return { title: 'US Shoe Size', value: dflt as string }
  }

  if (womens && womens !== dflt) {
    // Override the title, since some might say Mens Shoe Size when its unisex
    return { title: 'Shoe Size', value: `${dflt}M / ${womens}W`, classes: 'has-womens-size' }
  }

  // Use the default values
  return { title: attribute.title, value: dflt as string }
}
